import React, { useContext, useRef } from "react";
import cls from "classnames";
import _ from "lodash";
import Slider from "react-slick";
import { Global } from "../../App";

import "./Tools.scss";
import "../../Resource/scss/icon.scss";

/**
 * @typedef {{title: string, type: string}} item
 * @typedef {item[]} items
 */

/**
 * @param {object} props
 * @param {items} props.items
 * @param {(item)=> void} props.onSelected
 * @param {item} props.currentCategory
 *
 */

function Tool_circulatingTab({ items, onSelected, currentCategory, onRef }) {
  const { globalState, dispatchGlobal } = useContext(Global);
  let _tabRef = useRef(null);
  const settings = {
    centerMode: true,
    speed: 0,
    slidesToShow: 5,
    centerPadding: "0",
    arrows: false,
    swipe: false,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          centerMode: true,
          slidesToShow: 3
        }
      }
    ],
    beforeChange: (curr, next) => {
      onSelected(items[next]);
    }
  };

  if (!items || items.length < 1) {
    return null;
  }
  
  // console.log(items);
  return (
    <div className="Tool Tool__circulatingTab">
      <a
        className={cls(
          "Tool__circulatingTab__btn Tool__circulatingTab__btn_prev icn",
          globalState.device === "pc"
            ? "btn_menu_pre__pc"
            : "btn_menu_pre__mobile"
        )}
        onClick={() => _tabRef.slickPrev()}
      />
      <Slider
        {...settings}
        ref={ref => {
          console.log(ref, 'ref');
          _tabRef = ref;
          onRef(_tabRef);
        }}
      >
        {items.map((e, index) => (
          <div
            key={index}
            className={cls(
              "Tool__circulatingTab__item text-center",
              currentCategory.type === e.type
                ? "Tool__circulatingTab__item_selected"
                : "",
              globalState.fontSize === "pc" || globalState.fontSize === "xl"
                ? "Tool__circulatingTab__item_cusHeight"
                : ""
            )}
            onClick={()=>{
              _tabRef.slickGoTo(index)
            }}
          >
            <span>{e.title}</span>
          </div>
        ))}
      </Slider>
      <a
        className={cls(
          "Tool__circulatingTab__btn Tool__circulatingTab__btn_next icn",
          globalState.device === "pc"
            ? "btn_menu_next__pc"
            : "btn_menu_next__mobile"
        )}
        onClick={() => _tabRef.slickNext()}
      />
    </div>
  );
}

export default Tool_circulatingTab;
